/**
 * 商品卡(封面/标题/价格/销量)。多列网格单元,视觉套 app.css `.product-card`。
 * 空 productId 守卫:渲染但不可点(home.md 边界)。价格分→元、销量兜底 0。
 */
import { Link } from 'react-router-dom';
import type { ProductFeedItem } from '@/api/guide';
import { UNIT_LABEL } from '@/lib/productLabels';
import { formatYuan } from '@/lib/format';

export function ProductCard({ item }: { item: ProductFeedItem }) {
  const id = item.productId;
  const inner = (
    <>
      <div className="cover">
        {item.coverImageUrl ? (
          <img
            src={item.coverImageUrl}
            alt={item.title ?? '商品封面'}
            loading="lazy"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          '商品封面'
        )}
      </div>
      <div className="meta">
        <div className="pname">{item.title ?? '未命名商品'}</div>
        <div className="row between mt-2">
          <span className="price">
            ¥{formatYuan(item.price)}
            {item.unit ? <span className="unit">/{UNIT_LABEL[item.unit] ?? item.unit}</span> : null}
          </span>
          <span className="xs muted">已售 {item.salesCount ?? 0}</span>
        </div>
      </div>
    </>
  );

  if (!id) {
    return (
      <div className="product-card" aria-disabled="true" style={{ cursor: 'default' }}>
        {inner}
      </div>
    );
  }
  return (
    <Link to={`/product/${encodeURIComponent(id)}`} className="product-card">
      {inner}
    </Link>
  );
}
